export default {
  CREATE_TESTIMONIAL(state, payload) {},
  GET_TESTIMONIAL(state, payload) {
    state.singleTestimonial = payload;
  },
  GET_ALL_TESTIMONIAL(state, payload) {
    state.testimonial = payload;
  },
  UPDATE_TESTIMONIAL(state, payload) {},
  DELETE_TESTIMONIAL(state, payload) {},
  REDIRECT_TESTIMONIAL(state, payload) {
    state.redirect = payload;
  },
};
